// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-YwaH","delete":"styles_delete__3q7jQ","update":"styles_update__2yPfi","add":"styles_add__1ZSAk"};